/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Title
 */
export interface Title {
    /**
     * 
     * @type {number}
     * @memberof Title
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Title
     */
    name: string;
}

/**
 * Check if a given object implements the Title interface.
 */
export function instanceOfTitle(value: object): value is Title {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TitleFromJSON(json: any): Title {
    return TitleFromJSONTyped(json, false);
}

export function TitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Title {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function TitleToJSON(json: any): Title {
    return TitleToJSONTyped(json, false);
}

export function TitleToJSONTyped(value?: Title | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

